module.exports = __webpack_public_path__ + "img/app_4.4663e35a.jpg";